import { render, staticRenderFns } from "./FormFisico.vue?vue&type=template&id=76288133"
import script from "./FormFisico.vue?vue&type=script&lang=js"
export * from "./FormFisico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports